// LICENSE PROTECTED SOFTWARE
import React, { useEffect, useState, useRef } from 'react';
import { Clock, Upload, CheckCircle2, AlertCircle } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Button } from '../components/ui/button';
import { stkAPI } from '../lib/api';
import { toast } from 'sonner';

const STATUS = {
  bekliyor: { label: 'Bekliyor', cls: 'bg-amber-100 text-amber-800', icon: Clock },
  yuklendi: { label: 'Yuklendi', cls: 'bg-green-100 text-green-800', icon: CheckCircle2 },
  sonu_gecti: { label: 'Sonu Gecti', cls: 'bg-red-100 text-red-800', icon: AlertCircle },
};

export default function STKPendingDocRequests() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const fileRefs = useRef({});

  const load = async () => {
    try {
      setLoading(true);
      const r = await stkAPI.myPendingDocRequests();
      setItems(r.data.items || []);
    } catch (_) { /* silent */ }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const upload = async (itemId, file) => {
    if (!file) return;
    try {
      await stkAPI.uploadDocRequestItem(itemId, file);
      toast.success('Belge yuklendi');
      load();
    } catch (e) { toast.error(e.response?.data?.detail || 'Yukleme hatasi'); }
  };

  if (loading) return null;
  if (!items.length) return null;
  const pending = items.filter(i => i.status !== 'yuklendi');
  if (!pending.length) return null;

  return (
    <Card className="border-amber-300 bg-amber-50" data-testid="stk-pending-requests-widget">
      <CardContent className="p-5">
        <div className="flex items-center gap-2 mb-3">
          <AlertCircle className="w-5 h-5 text-amber-600"/>
          <h3 className="font-semibold text-amber-900">Bekleyen Belge Talepleri ({pending.length})</h3>
        </div>
        <div className="space-y-2">
          {items.map(i => {
            const S = STATUS[i.status] || STATUS.bekliyor;
            const Icon = S.icon;
            return (
              <div key={i.item_id} className="bg-white rounded-lg p-3 flex flex-wrap items-center gap-3">
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-sm">{i.title}</p>
                  <p className="text-xs text-slate-600">{i.document_type}</p>
                  {i.deadline && <p className="text-xs text-slate-500">Son tarih: {new Date(i.deadline).toLocaleDateString('tr-TR')}</p>}
                </div>
                <Badge className={S.cls}><Icon className="w-3 h-3 mr-1"/>{S.label}</Badge>
                {i.status !== 'yuklendi' && (
                  <>
                    <input ref={el => fileRefs.current[i.item_id] = el} type="file" className="hidden"
                           accept=".pdf,.jpg,.jpeg,.png,.gif,.doc,.docx,.xls,.xlsx"
                           onChange={e => upload(i.item_id, e.target.files[0])}/>
                    <Button size="sm" onClick={() => fileRefs.current[i.item_id]?.click()} data-testid={`upload-doc-req-${i.item_id}`}>
                      <Upload className="w-3 h-3 mr-1"/>Yukle
                    </Button>
                  </>
                )}
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
